"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObjectAnnotationSummary = void 0;
var tslib_1 = require("tslib");
var base_1 = require("./base");
var IkeObjectAnnotationSummary = /** @class */ (function (_super) {
    tslib_1.__extends(IkeObjectAnnotationSummary, _super);
    function IkeObjectAnnotationSummary() {
        var _this = _super.call(this) || this;
        _this.className = 'AnnotationSummary';
        _this.actionName = 'annotation.summary';
        _this.cacheKeys['uuid'] = true;
        _this.cacheKeys['revision'] = true;
        _this.cacheKeys['collectionId'] = true;
        return _this;
    }
    IkeObjectAnnotationSummary.prototype.updateCache = function (key, result, rest) {
        _super.prototype.updateCache.call(this, key, result, rest);
        this.cacheIfLatest('uuid', result, rest);
        this.cacheIfLatest('revision', result, rest);
        this.cacheIfLatest('collectionId', result, rest);
    };
    return IkeObjectAnnotationSummary;
}(base_1.IkeRestObject));
exports.IkeObjectAnnotationSummary = IkeObjectAnnotationSummary;
//# sourceMappingURL=annotation.summary.object.js.map